import React, { useEffect, useState } from 'react';
import { ListTree } from 'lucide-react';
import useContentGovernanceStore from '@/stores/SuperAdminStore/ContentGovernanceStore';
import CourseStructureTree from './CourseStructureTree';

/** Course Structure tab: pick a course, view its read-only section/lesson tree. */
const StructureTab: React.FC = () => {
  const { courses, fetchCourses, loadingCourses } = useContentGovernanceStore();
  const [selected, setSelected] = useState<number | ''>('');

  useEffect(() => { fetchCourses(''); }, [fetchCourses]);

  return (
    <div className="s-admin-ca-structuretab">
      <div className="s-admin-ca-add-row">
        <ListTree size={16} />
        <select
          className="s-admin-ca-select"
          value={selected}
          onChange={(e) => setSelected(e.target.value ? Number(e.target.value) : '')}
        >
          <option value="">{loadingCourses ? 'Loading courses…' : 'Select a course to inspect'}</option>
          {courses.map((c) => <option key={c.id} value={c.id}>{c.title} ({c.status})</option>)}
        </select>
      </div>
      {selected !== '' ? (
        <CourseStructureTree courseId={selected} />
      ) : (
        <div className="s-admin-ca-empty">Choose a course above to view its section/lesson structure.</div>
      )}
    </div>
  );
};

export default StructureTab;
